import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ReferenceLibraryService } from '../../../services/referenceLibrary.service';
import { ReferenceLibrary } from '../../../data/models/referenceLibrary.model';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { ConfirmationService } from "primeng/api";
import * as errorUtils from "src/app/modules/utility/global-utils";
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { LcaService } from 'src/app/services/lca.service';

@Component({
  selector: 'app-lca-details',
  templateUrl: './lca-details.component.html',
  styleUrls: ['./lca-details.component.scss']
})
export class LcaDetailsComponent implements OnInit, OnChanges{
  @Input() lcaEFileApplication: FormGroup;
  @Input() editLcaEFileApplication: any;

  visaTypeList: ReferenceLibrary[];
  visaType:any;
  maxDate = new Date();
  minDate: Date = new Date();
  fullPosition:any;
  startDate = new FormControl(new Date());
  endDate = new FormControl(new Date());
  destroy$ = new Subject();
  enableReadOnlyMode: boolean = true;
  showDateError: boolean = true;
  isDuplicateLCA: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute,
    private referenceLibraryService: ReferenceLibraryService,
    private confirmationService: ConfirmationService,
    private toastr: ToastrService,
    private lcaServices:LcaService,
    protected store: Store<any> 
    )
     {
    this.visaTypeList = [];

   }

  ngOnInit(): void {
    this.referenceLibraryService.getReferenceData('VISATYP').subscribe((response: ReferenceLibrary[]) => {
      this.visaTypeList = response && response.filter(ele => ele.code === 'H1-B' || ele.code === 'E3');
    });
    this.isDuplicateLCA = sessionStorage.getItem("isDuplicateLCA") === 'true';
    this.getInputField()
  }
  

  ngOnChanges(changes: SimpleChanges){
    if(changes.editLcaEFileApplication.currentValue){
      if(changes.editLcaEFileApplication.currentValue.placeList.length > 0){
        if(JSON.parse(localStorage.getItem('userEfileInfo'))){
          this.editLcaEFileApplication = JSON.parse(localStorage.getItem('userEfileInfo')).lcaApplication; 
          this.lcaEFileApplication.patchValue({
            visaType: this.editLcaEFileApplication.visaType.code,
            jobTitle: this.editLcaEFileApplication.jobTitle,
            socCode:this.editLcaEFileApplication.socCode,
            socTitle:this.editLcaEFileApplication.socTitle,
            isFullTime:this.editLcaEFileApplication.isFullTime,
            employmentEndDate: this.editLcaEFileApplication.employmentEndDate ? new Date(this.editLcaEFileApplication.employmentEndDate) : null,
            employmentStartDate: this.editLcaEFileApplication.employmentStartDate ? new Date(this.editLcaEFileApplication.employmentStartDate) : null,
            totalCount:this.editLcaEFileApplication.totalCount,
            newEmploymentCount: this.editLcaEFileApplication.newEmploymentCount,
            continueApprovedCount:this.editLcaEFileApplication.continueApprovedCount,
            changeApproveCount: this.editLcaEFileApplication.changeApproveCount,
            concurrentEmploymentCount: this.editLcaEFileApplication.concurrentEmploymentCount,
            employerChangeCount: this.editLcaEFileApplication.employerChangeCount,
            amendedPetitionCount:this.editLcaEFileApplication.amendedPetitionCount,
          });
      }
      }
    }
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  socCodeList:any;
  socCodeListFiltered:any;

  getInputField(){
       this.lcaServices.getDataFromService(true).subscribe((res: any) => {
        this.socCodeList = res.data
        this.socCodeListFiltered =  this.socCodeList
       // console.log('getDataFromService true',res)
       });   
   }


  

   onKey(value) { 
   // console.log('this.socCodeList',this.socCodeList)
    this.lcaEFileApplication.patchValue({     
      socTitle:'',  
      socCode:''
 
    });
   console.log('valuevaluevalue',value.toString())
    if(value.length > 2){
      console.log('this.socCodeList',this.socCodeList)
      var socCodeListFiltered = this.socCodeList.filter((item)=>item.socCode === value);

      this.lcaServices.getDatagetSocCodeList(true,value.toString()).subscribe((res: any) => {
        if(res){
          this.socCodeListFiltered = res.data ;
          console.log('socCodeListFiltered',res)
        }
      });  
    } 
    }
    
    onChangeOccupationTitle(id){
      console.log('onChangeOccupationTitle',id.version)
      localStorage.setItem('socVersionEfile','New')
       var socTitle = this.socCodeList.filter((item)=>item.socCode === id)[0].title;
       // console.log('socTitle',socTitle)
       this.lcaEFileApplication.patchValue({     
        socTitle:socTitle,
        socCode:id
      });
 }
   
 getListSocCOde(){
   console.log('this.searchSoc' )       
    this.socCodeListFiltered =  this.socCodeList
  }

  onChangeVisa(value){
    if(value){
      this.onChangeEndDate();
    }
  }

  onChangeEndDate() {
    if(this.lcaEFileApplication.controls.employmentStartDate.value && this.lcaEFileApplication.controls.employmentEndDate.value){
      let diffYear = (this.lcaEFileApplication.controls.employmentEndDate.value.getTime() - this.lcaEFileApplication.controls.employmentStartDate.value.getTime()) / 1000;
      diffYear /= (60 * 60 * 24);
      let diffResult = diffYear/365; 

      switch(this.lcaEFileApplication.controls.visaType.value) {
        case 'H1-B': 
              this.showDateError = diffResult <=3;
              break;
        case 'H1-B1': 
              this.showDateError = diffResult <=3;
              break;
        case 'E3': 
              this.showDateError = diffResult <=2;
              break;
        case 'default':
              break;
      }
    }
  }

  clearData() {
    // Clear any previous confirmation
    this.confirmationService.close();

    this.confirmationService.confirm({
      header: "Clear Data",
      icon: "pi pi-exclamation-triangle",
      rejectLabel: "Cancel",
      acceptLabel: "Yes, Clear Data",
      acceptButtonStyleClass: "btn-accept-clear",
      rejectButtonStyleClass: "btn-cancel-clear",
      message: `<div class="mb-4"> This will clear all the data from this section. </div>
                <div class="mb-4"> Are you sure, you want to clear data? </div>`,
      accept: () => {
        this.lcaEFileApplication.reset({newEmploymentCount: 0,
          continueApprovedCount: 0,
          changeApproveCount: 0,
          concurrentEmploymentCount: 0,
          employerChangeCount: 0,
          amendedPetitionCount: 0});
        this.confirmationService.close();
      },
      reject: () => {
        // Clear the confirmation dialog instance after rejection
       this.confirmationService.close();
     },
    });
  }

}
